import { render, staticRenderFns } from "./MaterialesView.vue?vue&type=template&id=3e45db9a&scoped=true"
import script from "./MaterialesView.vue?vue&type=script&lang=js"
export * from "./MaterialesView.vue?vue&type=script&lang=js"
import style0 from "./MaterialesView.vue?vue&type=style&index=0&id=3e45db9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45db9a",
  null
  
)

export default component.exports